import { ITransfert } from '../../interfaces/models';
import { Action } from '@ngrx/store';

export const SET = '[Transfert] Set';
export const ADD = '[Transfert] Add';
export const EDIT = '[Transfert] Edit';
export const DELETE = '[Transfert] Delete';
export const OPEN_MODAL = '[Transfert] Open modal';
export const CLOSE_MODAL = '[Transfert] Close modal';

export class Set implements Action {
  readonly type = SET;

  constructor(public data: ITransfert[]) {}
}

export class Add implements Action {
  readonly type = ADD;

  constructor(public data: ITransfert) {}
}

export class Edit implements Action {
  readonly type = EDIT;

  constructor(public data: ITransfert) {}
}

export class Delete implements Action {
  readonly type = DELETE;

  constructor(public id: any) {}
}

export class OpenModal implements Action {
  readonly type = OPEN_MODAL;
}

export class CloseModal implements Action {
  readonly type = CLOSE_MODAL;
}

export type All = Set | Add | Edit | Delete | OpenModal | CloseModal;
